import React from 'react';
import PropTypes from 'prop-types';
import LogoFieldView from './LogoFieldView';
import MediaLibrary from './MediaLibrary';
import useLogoField from './useLogoField';

/**
 * LogoField — container do campo Logo do editor de página. docs/PLANO-EXECUCAO-MIDIA.md TODO 8.1.
 * Visual: LogoFieldView + MediaLibrary em modo 'logo' (View do Claude Design + aviso da casa). Regra e dado: useLogoField.
 * `onChange` recebe o `identity` inteiro com `avatarAssetId`/`avatarOrigin`/`avatarUrl` já resolvidos.
 */
const LogoField = ({ identity, onChange }) => {
  const { vm, actions, library } = useLogoField({ identity, onChange });
  return (
    <>
      <LogoFieldView vm={vm} actions={actions} />
      <MediaLibrary vm={library.vm} actions={library.actions} />
    </>
  );
};

LogoField.propTypes = {
  identity: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default LogoField;
